import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';
import { PAGE_ROUTES } from '@/constants';

import {
  HeaderBurgerNav,
  HeaderFavorites,
  HeaderLogo,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderDefaultMobile = () => (
  <>
    <HeaderRow borderless type="small">
      <HeaderSection justify="start">
        <HeaderBurgerNav />
        <HeaderLogo fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow borderless type="flat">
      <HeaderSection justify="center">
        <SearchHeader seeAllHref={PAGE_ROUTES.SHOP} />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="small">
      <HeaderSection justify="center" spaceBetweenOnMultipleChildren>
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderDefaultMobile };
